import {
  PrimePoiApiRoot,
  PrimePoiApiPaths,
  MakeAuthHeader,
  TechnicianSubPaths
} from "../../config/api";
import axios from "axios";
import ApiCommunicationError from "../../exceptions/ApiCommunicationError";

const state = {
  notifications: [],
  messageToken: null,
  hasLoggedIn: false
};

const getters = {
  notifications(state) {
    return state.notifications;
  },
  messageToken(state) {
    return state.messageToken;
  },
  hasLoggedIn(state) {
    return state.hasLoggedIn;
  }
};

const actions = {
  deleteMessageToken({ commit, rootGetters, dispatch, state }) {
    const url = `${PrimePoiApiRoot}${PrimePoiApiPaths.Technician}removeToken`;
    let config = {
      method: "DELETE",
      headers: MakeAuthHeader(rootGetters["login/poiApiToken"]),
      data: {
        technicianId: rootGetters["login/technicianId"],
        token: state.messageToken
      },
      url: url
    };

    axios(config)
      .then(res => {
        if (res.data) {
          commit("clearMessageToken");
        }
      })
      .catch(error => {
        let err = new ApiCommunicationError(
          `Unable get the user notification token. Inner error details: message: ${error.message}, name: ${error.name}, stack: ${error.stack}`
        );
        dispatch("errors/sendError", err, { root: true });
        dispatch(
          "errors/expectedErrorAlert",
          `Apologies, we where unable to get your devices notification token. notifications may not work for this device.`,
          { root: true }
        );
      });
  },
  saveNotificationToken({ commit, dispatch, rootGetters }, { token, vm }) {
    let url = `${PrimePoiApiRoot}${PrimePoiApiPaths.Technician}${TechnicianSubPaths.Token}`;

    let config = {
      headers: MakeAuthHeader(rootGetters["login/poiApiToken"])
    };

    let model = {
      technicianId: rootGetters["login/technicianId"],
      token: token
    };
    axios
      .post(url, model, config)
      .then(res => {
        if (res.data) {
          commit("setMessageToken", token);
          commit("setHasLoggedIn", true);
          const weekInMilliseconds = 1000 * 60 * 60 * 24 * 7;
          vm.$ls.set("messageToken", token, weekInMilliseconds);
        }
      })
      .catch(error => {
        let err = new ApiCommunicationError(
          `Unable get the user notification token. Inner error details: message: ${error.message}, name: ${error.name}, stack: ${error.stack}`
        );
        dispatch("errors/sendError", err, { root: true });
        dispatch(
          "errors/expectedErrorAlert",
          `Apologies, we where unable to get your devices notification token. notifications may not work for this device.`,
          { root: true }
        );
      });
  }
};

const mutations = {
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  addNotifications(state, payload) {
    let currentNots = state.notifications;
    currentNots.push(payload);
    state.notifications = currentNots;
  },
  removeNotifications(state, payload) {
    let currentNots = state.notifications;
    let notId = payload.id;
    let index = currentNots.findIndex(element => {
      return element.id === notId;
    });
    currentNots.splice(index, 1);
    state.notifications = currentNots;
  },
  clearNotifications(state) {
    state.notifications = [];
  },
  setMessageToken(state, payload) {
    state.messageToken = payload;
  },
  clearMessageToken(state) {
    state.messageToken = null;
  },
  setHasLoggedIn(state, payload) {
    state.hasLoggedIn = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
